<script lang="ts">
  import type { MarkdownFile } from '../../parseMarkdown'

  export let docs: MarkdownFile[], selected: string

  // a hopeful order!
  const orderHint = ['Get Started', 'Features', 'Support']

  const categoriesObj = docs.reduce((acc, cur) => {
    if (cur.category === undefined) return acc
    acc[cur.category] = acc[cur.category] || []
    acc[cur.category].push(cur)
    return acc
  }, {})

  // makes them go into the right order
  const categories = orderHint.map((i) => {
    return categoriesObj[i] || [{ category: i }]
  })

  // adds the rest that aren't in any order
  Object.keys(categoriesObj)
    .filter((i) => !orderHint.includes(i))
    .forEach((i) => categories.push(categoriesObj[i]))
</script>

<nav>
  {#each categories as category}
    <h2>{category[0].category}</h2>
    <ul>
      {#each category as doc}
        <li class:selected={doc.filename === selected}>
          <a href={doc.filename === 'introduction' ? '/docs' : `/docs/${doc.filename}`}
            >{doc.filename === 'introduction' ? 'Introduction' : doc.title}</a
          >
        </li>
      {/each}
    </ul>
  {/each}
</nav>

<style>
  nav {
    background: var(--surface-bg-subtle);
    border: 1px solid var(--surface-border-subtle);
    padding: 0.75rem 0.25rem 0.75rem 0.75rem;
    margin-bottom: 2rem;
    border-radius: 6px;
    align-self: start;

    @media (prefers-color-scheme: dark) {
      background: var(--surface-bg);
    }

    @media (min-width: 500px) {
      padding: 0.75rem 0.75rem 0.75rem 1.25rem;
    }
  }
  h2 {
    font-size: 1rem;
    font-weight: 600;
    margin: 1rem 0 0;
  }
  ul {
    list-style-type: none;
    margin: 0.5rem 0 1rem;
    padding-left: 0.5rem;
  }
  li {
    font-size: 1rem;
    margin-bottom: 0.25rem;
  }
  li.selected a {
    color: var(--surface-text-interactive-hover);
  }
  a {
    display: block;
    padding: 0.375rem 0.5rem;
    color: var(--surface-text);
    border-radius: 4px;
  }
  a:hover {
    text-decoration: none;
    background: var(--surface-bg-subtle-hover);
  }
</style>
